export default function formatDateTimeString(date) {
  if (!date) {
    return '';
  }
  const dateObj = new Date(date);
  return (dateObj instanceof Date && !Number.isNaN(dateObj))
    ? `${dateObj.toLocaleString('en-US', { hour12: true })}` : '';
}
